import { useState } from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, TrendingUp, Watch, Boxes, BarChart3, Tag, Inbox, Sparkles, Send, MessageCircle, Star, Settings, Users, LogOut, Menu, ExternalLink, ShieldCheck, Share2, User, Contact } from "lucide-react";
import { useAuth, isAdmin } from "@/pages/admin/AdminAuth";

const NAV = [
  ["/admin", "Resumo", LayoutDashboard, false, true],
  ["/admin/interesse", "Interesse nos modelos", TrendingUp],
  ["/admin/relogios", "Relógios", Watch],
  ["/admin/stock", "Stock e reservas", Boxes],
  ["/admin/marcas", "Marcas", Tag],
  ["/admin/pedidos", "Pedidos", Inbox],
  ["/admin/clientes", "Clientes", Contact],
  ["/admin/opinioes", "Opiniões", Star],
  ["/admin/partilhas", "Relatório de partilhas", Share2],
  ["/admin/relatorio", "Relatório mensal", BarChart3],
  ["/admin/consultor", "Consultor de IA", Sparkles],
  ["/admin/integracoes", "Telegram", Send, "super"],
  ["/admin/whatsapp", "WhatsApp automático", MessageCircle, true],
  ["/admin/definicoes", "Definições", Settings],
  ["/admin/utilizadores", "Utilizadores", Users, true],
  ["/admin/registo-acessos", "Registo de acessos", ShieldCheck],
  ["/admin/perfil", "O meu perfil", User],
];

export const PageTitle = ({ title, sub, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
    <div><h1 className="text-3xl text-[#F3EFE6]">{title}</h1>{sub && <p className="text-sm text-[#A39E93] mt-2">{sub}</p>}</div>
    <div className="flex flex-wrap gap-3">{children}</div>
  </div>
);

export const Panel = ({ children, className = "", ...p }) => <div className={`bg-[#161512] border border-[#282520] p-5 ${className}`} {...p}>{children}</div>;
export const Label = ({ children }) => <span className="block text-[10px] uppercase tracking-[0.2em] text-[#A39E93] mb-1.5">{children}</span>;

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const items = NAV.filter(([, , , acl]) => acl === "super" ? user?.role === "superadmin" : !acl || isAdmin(user));
  return (
    <div className="min-h-screen bg-[#080706] text-[#F3EFE6] lg:flex" data-testid="admin-layout">
      <aside className={`${open ? "block" : "hidden"} lg:block lg:w-60 shrink-0 bg-[#0C0B09] border-r border-[#1f1d19] lg:min-h-screen`}>
        <div className="p-5 flex items-center gap-3 border-b border-[#1f1d19]">
          <img src="/emblem-square.png" alt="" className="w-9 h-9 rounded-full" />
          <div><p className="font-display tracking-[0.15em] text-sm">GOLDENTIME</p><p className="text-[10px] uppercase tracking-[0.2em] text-[#C8AE6E]">Backoffice</p></div>
        </div>
        <nav className="p-3 space-y-0.5">
          {items.map(([to, label, Icon, , end]) => (
            <NavLink key={to} to={to} end={end} onClick={() => setOpen(false)} data-testid={`admin-nav-${to.split("/")[2] || "dashboard"}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 text-sm rounded-sm transition-colors ${isActive ? "bg-[#C8AE6E]/12 text-[#E6D5AC]" : "text-[#A39E93] hover:text-[#F3EFE6] hover:bg-white/[0.03]"}`}>
              <Icon className="w-4 h-4" strokeWidth={1.4} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-[#1f1d19] mt-4 space-y-3">
          <p className="text-xs text-[#F3EFE6]/80" data-testid="admin-current-user">{user.name}<span className="block text-[10px] uppercase tracking-[0.2em] text-[#A39E93]">{user.role === "superadmin" ? "Super administrador" : user.role === "admin" ? "Administrador" : "Editor"}</span></p>
          <Link to="/" target="_blank" className="flex items-center gap-2 text-xs text-[#A39E93] hover:text-[#E6D5AC]"><ExternalLink className="w-3.5 h-3.5" /> Ver site</Link>
          <button onClick={logout} className="flex items-center gap-2 text-xs text-[#A39E93] hover:text-[#e0937f]" data-testid="admin-logout-button"><LogOut className="w-3.5 h-3.5" /> Terminar sessão</button>
        </div>
      </aside>
      <div className="flex-1 min-w-0">
        <div className="lg:hidden flex items-center justify-between px-4 h-14 border-b border-[#1f1d19]">
          <span className="font-display tracking-[0.15em] text-sm">GOLDENTIME</span>
          <button onClick={() => setOpen(!open)} aria-label="Menu" data-testid="admin-mobile-menu"><Menu className="w-5 h-5" /></button>
        </div>
        <main className="p-5 sm:p-8 lg:p-10 max-w-[1300px]"><Outlet /></main>
      </div>
    </div>
  );
}
